// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcaddd2b","453":"8ab44547","667":"e8f85e57","977":"02ea122d"}[chunkId] + ".chunk.js";
};